import { NgModule, APP_INITIALIZER, ErrorHandler, Type, ModuleWithProviders, Provider } from "@angular/core";
import { InternationalisationModule } from "./forked/angular-internationalisation";
import { CoreLanguageService } from "./services/language.service";

/** Core Custom Module */

// Module
const imports: Array<Type<any> | ModuleWithProviders | any[]> = [
  InternationalisationModule
];

// Exports
const exports_: Array<Type<any> | any[]> = [
  InternationalisationModule
];

// Provider
const providers: Provider[] = [
  CoreLanguageService
];

// Deklarationen
const declarations: Array<Type<any> | any[]> = [];

// Modul
const ngModule: NgModule = {
  declarations: declarations,
  imports: imports,
  exports: exports_,
  providers: providers
};

@NgModule(ngModule)
export class CoreCustomModule { }
